import React, {Component} from 'react';
import {Alert} from 'reactstrap';
import PropTypes from 'prop-types';
import './FormWrapper.css';
import _ from 'lodash';
import {sharedLabelsPath} from "../../../reducers/common/localization";
import {Utils} from '../../../utils/utils';

class FormWrapper extends Component {
    componentWillUnmount() {
        this.props.onResetState();
    }

    componentWillMount() {
        this.props.onResetState();
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.fetching !== nextProps.fetching && !this.props.hideOverlay){
            this.overlayRef.style.visibility = !nextProps.fetching  ? "hidden" : "visible";
        }
    }

    render() {
        return (
            <div className="form-wrapper-container">
                <div id="form-wrapper-content-overlay" ref={(element) => this.overlayRef = element}/>
                    {this.getAlert()}
                {this.props.children}
            </div>
        );
    }

    getAlert = () => {
        if (this.props.disabled) {
            return null;
        }
        if (this.props.fetching) {
            return <Alert color="warning" className="notification-alert fetching-label">
                {this.props.loadingMessage || _.get(this.props.translation, sharedLabelsPath.fetching_message)}
            </Alert>;
        } else if (this.props.success && this.props.showSuccessAlert) {
            return <Alert color="success" className="notification-alert success-label" toggle={this.props.onResetState}>
                {this.props.successMessage || _.get(this.props.translation, sharedLabelsPath.success_message)}
            </Alert>;
        } else if (!_.isNil(this.props.error)) {
            let errorLabel = _.get(this.props.translation, sharedLabelsPath.errors)[this.props.error] || _.get(this.props.translation, sharedLabelsPath.defaultError);
            return <Alert color="danger" className="notification-alert error-label"
                          toggle={this.props.onCloseAlert}><div>{Utils.getTagsFromStringWithStyles(errorLabel)}</div></Alert>
        }
    }
}

FormWrapper.propTypes = {
    error: PropTypes.string,
    fetching: PropTypes.bool,
    success: PropTypes.bool,
    showSuccessAlert: PropTypes.bool,
    successMessage: PropTypes.string,
    loadingMessage: PropTypes.string,
    disabled: PropTypes.bool,
    hideOverlay: PropTypes.bool,
    translation: PropTypes.object.isRequired,
    onResetState: PropTypes.func.isRequired,
    onCloseAlert: PropTypes.func.isRequired
};

FormWrapper.defaultProps = {
    showSuccessAlert: true
};

export default FormWrapper;



// WEBPACK FOOTER //
// ./src/components/commonComponents/formWrapper/FormWrapper.js